import { Box } from '../../Box';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { ChevronDownIcon, ChevronUpIcon } from '../../Icons';
import { resolveInputFontSize, resolveInputSize } from '../../TextInput/TextInputStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveColor = (disabled, hasError, theme, readOnly) => {
  if (disabled || readOnly) {
    return theme.tokens.SemColorOnSurfaceInteractiveDisabled;
  } else if (hasError) {
    return theme.tokens.SemColorOnSurfaceErrorDefault;
  } else {
    return theme.tokens.SemColorOnSurfaceInteractiveRest;
  }
};
export const resolvePadding = size => {
  switch (size) {
    case 'small':
    case 'sm':
      return '8px';
    case 'large':
    case 'lg':
      return '14px';
    case 'medium':
    case 'md':
    default:
      return '12px';
  }
};
const resolveStyle = (theme, size, disabled, hasError, readOnly) => ({
  display: 'flex',
  width: resolveInputSize(theme, size),
  padding: resolvePadding(size),
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch',
  borderLeft: !disabled ? `1px solid ${theme.tokens.SemColorBorderDefault}` : `1px solid ${theme.tokens.SemColorBorderInteractiveDisabled}`,
  color: resolveColor(disabled, hasError, theme, readOnly),
  fontSize: resolveInputFontSize(theme, size),
  lineHeight: '100%',
  cursor: !disabled ? 'pointer' : 'not-allowed'
});
export const OpenButton = props => {
  const theme = useInterstateTheme();
  const {
    size,
    disabled,
    onClick,
    listBoxIsOpen,
    hasError,
    readOnly
  } = props;
  const style = resolveStyle(theme, size, disabled, hasError, readOnly);
  const handleOnClick = e => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };
  return /*#__PURE__*/_jsx(Box, {
    sx: style,
    className: 'ids-combo-box-open-button',
    onClick: handleOnClick,
    children: listBoxIsOpen ? /*#__PURE__*/_jsx(ChevronUpIcon, {
      fontSize: resolveInputFontSize(theme, size)
    }) : /*#__PURE__*/_jsx(ChevronDownIcon, {
      fontSize: resolveInputFontSize(theme, size)
    })
  });
};